module.exports = __webpack_public_path__ + "static/lookalikeNo-3af4350bbbe9f04023327568595f3fb8.png";